import { css } from 'emotion';

export const modalBody = css`
  margin: 10px 0 20px;
  > hr {
    margin-top: 20px;
  }
`;

export const modalText = css`
  padding: 0 20px;
`;
